module.exports = __webpack_public_path__ + "files/e0265b6c56816f43856f5b57ee5352e0.png";